import { ViewController } from '@estee/elc-service';
import { action, computed, observable } from 'mobx';
import { StoresRepository } from '~repositories/StoresRepository';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/StoresService';

export class StoresCountAndDirectoryViewController extends ViewController {
    @observable private storesRepository: StoresRepository;

    constructor() {
        super();
        this.storesRepository = diContainer.get(serviceNames.storesRepository);
    }

    @action
    public loaded = async () => {
        this.isLoading = false;
    };

    @computed
    public get data() {
        return {
            stores: this.storesRepository.stores,
            areStoresLoading: this.storesRepository.isLoading
        };
    }
}
